import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarkerPin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M14.773 13.417 10 18.25l-4.773-4.833c-2.636-2.669-2.636-6.996 0-9.665a6.691 6.691 0 0 1 9.546 0c2.636 2.669 2.636 6.996 0 9.665Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M12.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		})
	]
});
const ForwardRef = forwardRef(SvgMarkerPin);
export { ForwardRef as ReactComponent };
